// extracted by mini-css-extract-plugin
export default {"srOnly":"SrStatusText_srOnly__yNhCH"};